module.exports = __webpack_public_path__ + "img/contact-img.b0734bcb.jpg";